import { render } from "./CmdDefault.vue?vue&type=template&id=3673f418&scoped=true"
import script from "./CmdDefault.vue?vue&type=script&lang=js"
export * from "./CmdDefault.vue?vue&type=script&lang=js"

import "./CmdDefault.vue?vue&type=style&index=0&id=3673f418&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3673f418"]])

export default __exports__